var map = {
	"./t1.png": "f14c",
	"./t1_ok.png": "d7b0",
	"./t2.png": "bbe7",
	"./t2_ok.png": "1898",
	"./t3.png": "cea7",
	"./t3_ok.png": "c39b",
	"./tab_bg.png": "19c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "024c";